import React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';

export default React.memo(props => (
  <SvgIcon {...props} width="16" height="16" viewBox="0 0 16 16" fill="none">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M3.16666 9.33329C3.44281 9.33329 3.66666 9.55715 3.66666 9.83329V10.8333C3.66666 11.6617 4.33823 12.3333 5.16666 12.3333H10.8333C11.6618 12.3333 12.3333 11.6618 12.3333 10.8333V9.83329C12.3333 9.55715 12.5572 9.33329 12.8333 9.33329C13.1095 9.33329 13.3333 9.55715 13.3333 9.83329V10.8333C13.3333 12.214 12.2141 13.3333 10.8333 13.3333H5.16666C3.78596 13.3333 2.66666 12.214 2.66666 10.8333V9.83329C2.66666 9.55715 2.89052 9.33329 3.16666 9.33329Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8 2.83329C8.27614 2.83329 8.5 3.05715 8.5 3.33329V9.49996C8.5 9.7761 8.27614 9.99996 8 9.99996C7.72386 9.99996 7.5 9.7761 7.5 9.49996V3.33329C7.5 3.05715 7.72386 2.83329 8 2.83329Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8 2.66663C8.13903 2.66663 8.27179 2.72452 8.36639 2.8264L10.5331 5.15973C10.721 5.36209 10.7092 5.67845 10.5069 5.86636C10.3045 6.05426 9.98817 6.04254 9.80027 5.84018L8 3.90143L6.19973 5.84018C6.01183 6.04254 5.69546 6.05426 5.49311 5.86636C5.29075 5.67845 5.27903 5.36209 5.46693 5.15973L7.6336 2.8264C7.72821 2.72452 7.86096 2.66663 8 2.66663Z"
      fill="currentColor"
    />
  </SvgIcon>
));
